import React, { useEffect } from 'react'
import { TabsPanel, useTraversal, useLocation } from '@guillotinaweb/react-gmi'
import { message } from 'antd'

export function TabsPanelWithLock({ editableTabs = [], ...props }) {
  const Ctx = useTraversal()
  const [location] = useLocation()
  const tab = location.get('tab') || props.currentTab

  // onMount
  useEffect(() => {
    let unmounted = false
    let timeout, closeMsg

    if (!editableTabs.includes(tab)) return

    if (!Ctx.hasPerm('guillotina.ModifyContent')) {
      closeMsg = message.error({
        content: 'You do not have authorization to modify the content',
        key: 'modify-perm-error',
        duration: 0, // infinite
      })

      return () => {
        if (closeMsg) closeMsg()
      }
    }

    async function lock() {
      clearTimeout(timeout)

      let date, res
      const key = `last-mod-date:${Ctx.path}`
      const lastModDateStoraged = sessionStorage.getItem(key)
      const lastModDate =
        lastModDateStoraged || Ctx.state.context.modification_date

      // save to sessionStorage
      if (!lastModDateStoraged) {
        sessionStorage.setItem(key, lastModDate)
      }

      // It only locks if the current browser tab is this one.
      // If the focus is on the other tab, it will continue to
      // set timeouts and lock again when the window is open.
      if (document.visibilityState === 'visible') {
        res = await Ctx.client.lock(Ctx.path)
        date = res.modification_date

        // If there is an error, it means that another user has
        // locked the resource, then, we show a message that is
        // only removed when unmounting the tab component, that
        //is, when leaving the resource act
        if (res.error) {
          closeMsg = message.error({
            content: res.error,
            key: 'lock-error',
            duration: 0, // infinite
          })
        }
      }

      // If it has the date of the last modification that returns the
      // lock is different from the last one we have registered, it
      // means that it has left the window so long inactive that it
      // has stopped locking the resource to the point that another
      // user has modified content. It may be that the resource is now
      // locked by someone or not, but it is outdated, so we force a refresh.
      if (
        date &&
        new Date(date).getTime() !== new Date(lastModDate).getTime()
      ) {
        Ctx.refresh({ transparent: true })
      }

      if (!res?.error && !unmounted) {
        // The lock expires after 60s, so we need to constantly call the endpoint
        // @lock to keep it alive
        timeout = setTimeout(lock, 30 * 1000)
      }
    }

    lock()
    window.addEventListener('focus', lock)

    // cleanup (unmount)
    return () => {
      unmounted = true
      clearTimeout(timeout)
      if (closeMsg) closeMsg()
      sessionStorage.removeItem(`last-mod-date:${Ctx.path}`)
      window.removeEventListener('focus', lock)
      Ctx.client.unlock(Ctx.path)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab])

  return <TabsPanel {...props} />
}
